import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailService } from 'src/app/services/email.service';

@Component({
  selector: 'app-compra',
  templateUrl: './compra.component.html',
  styleUrls: ['./compra.component.scss']
})
export class CompraComponent implements OnInit {
  contactForm: FormGroup;
  submitted = false;
  emailEnviado = false;

  constructor(private formBuilder: FormBuilder, private emailService: EmailService) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      nome: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      empresa: ['', Validators.required],
      celular: ['', Validators.required],
      assunto: ['', Validators.required],
      qty: ['', Validators.required],
      mensagem: ['', Validators.required]
    });
  }

  get formControls() {
    return this.contactForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.contactForm.invalid) {
      return;
    }

    var form = {
      nome: this.contactForm.get('nome')?.value,
      email: this.contactForm.get('email')?.value,
      empresa: this.contactForm.get('empresa')?.value,
      telefone: this.contactForm.get('celular')?.value,
      assunto: this.contactForm.get('assunto')?.value,
      mensagem: this.contactForm.get('mensagem')?.value +
        ".  Quantidade de canetas solicitadas : " + this.contactForm.get('qty')?.value,
      qtd: this.contactForm.get('qty').value.toString()
    };

    this.emailService.sendMailCaneta(form).then(
      (r) => {
        this.emailEnviado = true;
      }).catch(e => {
        console.error('Erro ao enviar email:', e);
      });

  }


  enviarOutro() {
    this.emailEnviado = !this.emailEnviado;
  }

}
